import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Catalogos", items: [
      { label: "Departamentos", icon: "fas fa-clipboard-list", color: "#3b82f6", href: "/Departamentos", desc: "Catalogo de departamentos", enabled: !!user.menu_departamentos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Catalogos"
      descripcion="Catalogos generales del sistema"
      icono="fas fa-clipboard-list"
      color="#3b82f6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesCatalogos;
